module.exports = __webpack_public_path__ + "img/Frame2.f3760640.png";